







































import CFMDialog from '@/scripts/CFMDialog';
import { Component } from 'vue-property-decorator';

interface GuideItem {
  /** Kolon basligi: tablodaki ile ayni dil anahtari, rehber ile tablo birbirinden kopmasin. */
  term: string;
  text: string;
}

interface GuideSection {
  title: string;
  note?: string;
  items: GuideItem[];
}

/**
 * "Rol Bazli Adim Adim Hesap" tablosunun rehberi: her kolonun ne oldugu ve nasil hesaplandigi,
 * hukum kurallari ve kapsam. Salt okunur; CFM'in sagdan acilan dialog kalibi (modal-side).
 * Icerik tamamen dil dosyasindan gelir; kolon adlari tablonun kendi anahtarlarini kullanir.
 */
@Component<FteGuideDialog>({})
export default class FteGuideDialog extends CFMDialog {
  readonly sections: GuideSection[] = [
    {
      title: 'fte_guide_capacity_title',
      items: [
        { term: 'role', text: 'fte_guide_role' },
        { term: 'staff', text: 'fte_guide_staff' },
        { term: 'fte_gross_hours', text: 'fte_guide_gross' },
        { term: 'fte_leave_hours', text: 'fte_guide_leave' },
        { term: 'fte_net_hours', text: 'fte_guide_net' },
      ],
    },
    {
      title: 'fte_guide_coverage_title',
      note: 'fte_guide_coverage_note',
      items: [
        { term: 'fte_coverage_fte', text: 'fte_guide_coverage_fte' },
        { term: 'fte_coverage_gap', text: 'fte_guide_coverage_gap' },
        { term: 'fte_coverage_status', text: 'fte_guide_coverage_status' },
      ],
    },
    {
      title: 'fte_guide_demand_title',
      items: [
        { term: 'fte_available_hours', text: 'fte_guide_available' },
        { term: 'fte_planned_hours', text: 'fte_guide_planned' },
        { term: 'fte_incident_hours', text: 'fte_guide_incident' },
        { term: 'fte_demand_hours', text: 'fte_guide_demand' },
        { term: 'fte_surplus_hours', text: 'fte_guide_surplus' },
        { term: 'fte_surplus_percent', text: 'fte_guide_surplus_percent' },
        { term: 'status', text: 'fte_guide_status' },
      ],
    },
  ];

  /** Madde listeli bolumler: hukum kurallari ve kapsam. */
  readonly bulletSections: { title: string; keys: string[] }[] = [
    {
      title: 'fte_guide_rules_title',
      keys: [
        'fte_guide_rule_insufficient',
        'fte_guide_rule_marginal',
        'fte_guide_rule_sufficient',
        'fte_guide_rule_coverage',
        'fte_guide_rule_total',
      ],
    },
    {
      title: 'fte_guide_scope_title',
      keys: [
        'fte_guide_scope_year',
        'fte_guide_scope_rules_as_of',
        'fte_guide_scope_works',
        'fte_guide_scope_without_role',
        'fte_guide_scope_without_period',
        'fte_guide_scope_excluded_roles',
        'fte_guide_scope_deviation',
        'fte_guide_scope_no_overtime',
      ],
    },
  ];
}
